import type { HourRow } from "../components/types.js"

export function getTopPicks(rows: HourRow[], isMoon: boolean): HourRow[] {
  if (!rows.length) return []

  // Filter to only rows that are at least WARN status (not red/NO)
  const validRows = rows.filter(row => {
    const elev = row.target.elev >= 30 ? "ok" : "red"
    const moonSep = row.target.moonSeparation ?? 0
    const moon = isMoon || moonSep >= 30 ? "ok" : "red"

    // Use twilight marker for sun check
    const twilight = row.target.twilight ?? ""
    const sun =
      twilight === "" || twilight === " " || twilight === "A" || twilight === "N"
        ? "ok"
        : "red"

    return elev !== "red" && moon !== "red" && sun !== "red"
  })

  if (!validRows.length) return []

  const scored = validRows.map(row => {
    let score = 0

    // 1. Elevation priority (continuous scoring)
    const targetElev = row.target.elev
    const elevScore = 500 + ((targetElev - 30) / 60) * 1500
    score += elevScore

    // 2. Moon angle (skip when viewing Moon)
    if (!isMoon) {
      const moonSep = row.target.moonSeparation ?? 0
      score += (moonSep / 180) * 300
    }

    // 3. Night quality
    const twilight = row.target.twilight ?? ""
    switch (twilight) {
      case "":
      case " ":
        score += 200
        break
      case "A":
        score += 150
        break
      case "N":
        score += 100
        break
      case "C":
        score += 50
        break
      // Day gets 0
    }

    return { row, score }
  })

  return scored
    .sort((a, b) => b.score - a.score)
    .slice(0, 3)
    .map(s => s.row)
}





